module.exports = "<h3 class=\"text-normal\">{{ text }}</h3>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/setting-section-description/setting-section-description.html
// module id = ./web/modern/components/settings/common/setting-section-description/setting-section-description.html
// module chunks = 0